import React, { useState } from "react";
import { Link } from "react-router-dom";
import PageContainer from "../components/container/Container";
import { FiArrowRight, FiMapPin, FiClock, FiUsers, FiTrendingUp } from "../assets/icons/vander";
import JobApplicationForm from "../components/careers/JobApplicationForm";

export default function Careers() {
  const [showApplicationForm, setShowApplicationForm] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  const handleApplyNow = (job) => {
    setSelectedJob(job);
    setShowApplicationForm(true);
  };

  const handleCloseForm = () => {
    setShowApplicationForm(false);
    setSelectedJob(null);
  };

  const handleApplicationSuccess = () => {
    // You can add additional logic here if needed
    console.log("Application submitted successfully");
  };

  const jobOpenings = [
    {
      id: 1,
      title: "Senior AI/ML Engineer",
      department: "AI/ML Team",
      location: "Remote / Pune, Jaipur, India",
      type: "Full-time",
      experience: "3-5 years",
      description: "We're looking for a passionate AI/ML Engineer to join our team and help build cutting-edge computer vision and machine learning solutions.",
      requirements: [
        "Strong experience in Python, TensorFlow, PyTorch",
        "Experience with computer vision and deep learning",
        "Knowledge of cloud platforms (AWS, Azure, GCP)",
        "Experience with MLOps and model deployment"
      ]
    },
    {
      id: 2,
      title: "DevOps Engineer",
      department: "Infrastructure Team",
      location: "Remote / Pune, Jaipur, India",
      type: "Full-time",
      experience: "2-4 years",
      description: "Join our infrastructure team to help build and maintain scalable cloud solutions and CI/CD pipelines.",
      requirements: [
        "Experience with AWS, Docker, Kubernetes",
        "Strong knowledge of CI/CD tools (Jenkins, GitLab CI)",
        "Experience with infrastructure as code (Terraform, CloudFormation)",
        "Knowledge of monitoring and logging tools"
      ]
    }
  ];

  const benefits = [
    {
      icon: FiUsers,
      title: "Collaborative Culture",
      description: "Work with talented professionals in a supportive and innovative environment"
    },
    {
      icon: FiTrendingUp,
      title: "Career Growth",
      description: "Continuous learning opportunities and clear career progression paths"
    },
    {
      icon: FiClock,
      title: "Flexible Work",
      description: "Remote work options and flexible hours to maintain work-life balance"
    },
    {
      icon: FiMapPin,
      title: "Global Impact",
      description: "Work on projects that make a real difference in the world"
    }
  ];

  return (
    <PageContainer
      title="Careers - CodeElan Technologies"
      description="Join our team of innovators and help shape the future of AI and technology. Explore exciting career opportunities at CodeElan Technologies."
    >
      {/* Hero Section */}
      <section className="hero-section contact-hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-8 mx-auto text-center">
                <div className="hero-content">
                  <div className="hero-accent"></div>
                  <h1 className="hero-title">
                    Join Our <span className="text-primary">Team</span>
                  </h1>
                  <p className="hero-subtitle">
                    Be part of a team that's shaping the future of AI and technology. 
                    Work on cutting-edge projects that make a real impact.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Join Us Section */}
      <section className="section">
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8 text-center">
              <h2 className="section-title">Why Join CodeElan?</h2>
              <p className="section-subtitle">
                Discover what makes CodeElan a great place to work and grow your career
              </p>
            </div>
          </div>
          <div className="row">
            {benefits.map((benefit, index) => (
              <div key={index} className="col-lg-3 col-md-6 mb-4">
                <div className="benefit-card text-center">
                  <div className="benefit-icon">
                    <benefit.icon />
                  </div>
                  <h4 className="benefit-title">{benefit.title}</h4>
                  <p className="benefit-description">{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Job Openings Section */}
      <section className="section cta-section">
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-8 text-center">
              <h2 className="section-title">Open Positions</h2>
              <p className="section-subtitle">
                Explore our current job openings and find the perfect role for your skills and career goals
              </p>
            </div>
          </div>
          <div className="row">
            {jobOpenings.map((job) => (
              <div key={job.id} className="col-lg-6 mb-4">
                <div className="job-card">
                  <div className="job-header">
                    <h3 className="job-title">{job.title}</h3>
                    <span className="job-department">{job.department}</span>
                  </div>
                  <div className="job-meta">
                    <div className="job-meta-item">
                      <FiMapPin className="meta-icon" />
                      <span>{job.location}</span>
                    </div>
                    <div className="job-meta-item">
                      <FiClock className="meta-icon" />
                      <span>{job.type}</span>
                    </div>
                    <div className="job-meta-item">
                      <FiUsers className="meta-icon" />
                      <span>{job.experience}</span>
                    </div>
                  </div>
                  <p className="job-description">{job.description}</p>
                  <div className="job-requirements">
                    <h5>Key Requirements:</h5>
                    <ul>
                      {job.requirements.map((req, index) => (
                        <li key={index}>{req}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="job-action">
                    <button 
                      className="btn btn-primary"
                      onClick={() => handleApplyNow(job)}
                    >
                      Apply Now
                      <FiArrowRight className="ms-2" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h2 className="section-title">Don't See the Right Role?</h2>
              <p className="section-subtitle">
                We're always looking for talented individuals to join our team. 
                Send us your resume and let's discuss how you can contribute to our mission.
              </p>
              <div className="cta-buttons">
                <button 
                  className="btn btn-primary btn-lg"
                  onClick={() => handleApplyNow({ title: "General Application" })}
                >
                  Apply for General Position
                  <FiArrowRight className="ms-2" />
                </button>
                <Link to="/contactus" className="btn btn-outline-primary btn-lg ms-3">
                  Contact Us
                  <FiArrowRight className="ms-2" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Job Application Form Modal */}
      {showApplicationForm && (
        <JobApplicationForm
          jobTitle={selectedJob?.title}
          onClose={handleCloseForm}
          onSuccess={handleApplicationSuccess}
        />
      )}
    </PageContainer>
  );
} 